import React from 'react'
import { IconProps } from '../types'

export default function UpArrowIcon2({
    className = 'h-4 w-4',
    stroke = 'currentColor',
    strokeWidth = 1.6,
    strokeOpacity = 0.2,
    ...props
}: IconProps) {
    return (
        <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M5.80078 0.800781V12.8008M5.80078 0.800781L10.8008 5.94364M5.80078 0.800781L0.800781 5.94364"
                stroke={stroke}
                strokeOpacity={strokeOpacity}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
